import { Link, useParams, useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import DeletePostButton from '../components/DeletePostButton';
import EditPostForm from '../components/EditPostForm';
import AddLikeButton from "../components/AddLikeButton";
import Comment from "../components/Comment";
import AddCommentButton from "../components/AddCommentButton";

import { useAuthContext } from '../hooks/useAuthContext';
import { useQuery } from '@apollo/client';
import { GET_POST } from '../queries/postQueries';
import { GET_USER_PROFILE } from '../queries/userQueries';

export default function Post() {
  const { id } = useParams()
  const { loading, error, data, refetch } = useQuery(GET_POST, { variables: { id } })
  const { authUser, isAdmin } = useAuthContext()
  const navigate = useNavigate()

  const { loading: userLoading, error: userError, data: userData, refetch: refetchUser } = useQuery(GET_USER_PROFILE, {
    variables: { id: data?.post?.userId || 1 }
  })

  if (loading) return <Spinner marginSize='60px' />
  if (error) return <p>Something Went Wrong</p>

  const date = new Date(data.post.createdAt)
  refetchUser()
  refetch()

  if (userError) return <p>Error loading user data: {userError.message}</p>

  const isPostOwner = () => {
    if (authUser.id === data?.post?.userId) {
      return true
    }
    return false
  }

  return (
    <>
      {!loading && !error && (
        <div className='card w-100 p-5'>
          <Link to='/' className='btn btn-sm btn-violet d-inline ms-auto rfs-4'>
            Back
          </Link>

          {userLoading ? (
            <div>
              <Spinner marginSize='50px' />
            </div>
          ) : (<>
            <div className='card-title d-flex flex-column fw-bold text-rose mt-4'>
              <p className="text-end rfs-3">{date.toLocaleDateString()} - {date.toLocaleTimeString()}</p>
              <p className='rfs-2'>
                <span className="cursor-pointer" onClick={() => navigate(`/users/${userData.userProfile.id}`)}>
                  @{userData.userProfile.username}
                </span>
              </p>
            </div>

            <p className='card-text rfs-2'>{data.post?.content}</p>

            {data.post?.imageUrl && (
              <img
                src={data.post?.imageUrl}
                className='text-center my-2'
                alt=''
              />
            )}

            <div>
              <AddLikeButton postId={data.post.id} />
              <AddCommentButton postId={data.post.id} />
            </div>

            <div className='d-flex row justify-content-center'>
              {data.post.comments?.map((comment, index) => (
                <Comment key={index} comment={comment} postId={data.post.id} refetchPost={refetch} />
              ))}
            </div>

            {/*<ul>
              {data.post?.comments.map((comment) => {
                return (
                  <li key={comment.id}>{comment.content}</li>
                )
              })}
            </ul>*/}

            {isPostOwner() && (
              <EditPostForm post={data.post} />
            )}

            {(isAdmin || isPostOwner()) && (
              <DeletePostButton postId={data.post.id} />
            )}
          </>)}
        </div>
      )}
    </>
  )
}
